/* Loop-style homepage rebuild — slider + nav behavior */
(function () {
  'use strict';

  /* ---------- Peek sliders (.lswiper) ---------- */
  function initSwiper(root) {
    var track = root.querySelector('.lswiper__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('.lswiper__btn--prev');
    var next = root.querySelector('.lswiper__btn--next');
    var dotsWrap = root.querySelector('.lswiper__dots');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.lswiper__dot')) : [];
    var nums = Array.prototype.slice.call(root.querySelectorAll('.pg-num'));

    function slideWidth() {
      if (!slides.length) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }
    function index() {
      return Math.round(track.scrollLeft / slideWidth());
    }
    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
    }
    function update() {
      var i = index();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      nums.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - Math.floor(track.clientWidth / slideWidth() + 0.01);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
    nums.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });
    update();

    /* autoplay (hero) — advance when video ends; timer fallback for image slides */
    if (root.hasAttribute('data-autoplay')) {
      var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 6000;
      var paused = false;
      var timer = null;
      var settleTimer;
      var current = -1; /* index whose video is currently scheduled/playing */

      /* Progress bar: a single track moved to sit right after the active number,
         filling 0→100% over the slide's duration (the video's real playback time
         when present, else the autoplay delay). Shows where the slide is and when
         the next one arrives. */
      var progressEl = root.querySelector('.hero__progress');
      var progressFill = progressEl && progressEl.querySelector('.hero__progress-fill');
      var progRaf = null;
      var progStart = 0;

      function setProgress(p) {
        if (progressFill) progressFill.style.width = (Math.max(0, Math.min(1, p)) * 100) + '%';
      }
      function stopProgress() {
        if (progRaf) cancelAnimationFrame(progRaf);
        progRaf = null;
      }
      function moveProgressToActive(i) {
        if (!progressEl) return;
        var num = nums[i];
        if (num && num.parentNode) num.parentNode.insertBefore(progressEl, num.nextSibling);
      }
      function runProgress(i) {
        stopProgress();
        var video = slides[i] && slides[i].querySelector('video');
        progStart = performance.now();
        (function tick(now) {
          var p;
          if (video && video.duration > 0 && !isNaN(video.duration)) {
            p = video.currentTime / video.duration;
          } else {
            p = (now - progStart) / delay;
          }
          setProgress(p);
          if (p < 1) progRaf = requestAnimationFrame(tick);
        })(progStart);
      }

      function clearScheduled() {
        clearTimeout(timer);
        timer = null;
        stopProgress();
        slides.forEach(function (s) {
          var v = s.querySelector('video');
          if (v) v.removeEventListener('ended', advance);
        });
      }

      function scheduleSlide(i) {
        clearScheduled();
        current = i;
        moveProgressToActive(i);
        setProgress(0);
        if (paused) return;
        slides.forEach(function (s, j) {
          var v = s.querySelector('video');
          if (!v) return;
          if (j === i) {
            v.muted = true; v.playsInline = true; v.currentTime = 0;
            var pp = v.play();
            if (pp && pp.catch) { pp.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
          }
          else { v.pause(); v.currentTime = 0; }
        });
        var video = slides[i] && slides[i].querySelector('video');
        if (video) {
          video.addEventListener('ended', advance);
        } else {
          timer = setTimeout(advance, delay);
        }
        runProgress(i);
      }

      function advance() {
        var i = index();
        var nextI = i >= slides.length - 1 ? 0 : i + 1;
        goTo(nextI);
        scheduleSlide(nextI); /* start the incoming video now, while it scrolls in */
      }

      /* Pick each video's source for the current viewport (mobile vs desktop).
         The `media` attribute is ignored on a <video>'s <source>, so we set the
         src in JS from data-src-desktop / data-src-mobile. Re-runs on breakpoint
         change so resizing across 768px swaps the clip too. */
      var heroMq = window.matchMedia('(max-width: 767px)');
      function resolveSources() {
        slides.forEach(function (s) {
          var v = s.querySelector('video');
          if (!v || !v.dataset.srcDesktop) return;
          v.muted = true; v.playsInline = true; /* required for mobile autoplay */
          var want = (heroMq.matches && v.dataset.srcMobile) ? v.dataset.srcMobile : v.dataset.srcDesktop;
          if (v.getAttribute('src') !== want) { v.src = want; v.muted = true; v.load(); }
        });
      }
      resolveSources();
      if (heroMq.addEventListener) {
        heroMq.addEventListener('change', function () { resolveSources(); scheduleSlide(index()); });
      }

      scheduleSlide(0);

      /* Warm up the other slides' videos up front so manual navigation never
         waits on buffering. The active slide (0) is already playing; force the
         rest to start downloading immediately. */
      slides.forEach(function (s, j) {
        if (j === 0) return;
        var v = s.querySelector('video');
        if (v) { v.preload = 'auto'; v.load(); }
      });

      /* Manual navigation: start the target slide's video immediately on click
         (the buttons' goTo handlers above only scroll). Without this the video
         wouldn't play until the scroll settled + 600ms, which felt like a delay. */
      function jumpTo(i) { scheduleSlide(Math.max(0, Math.min(i, slides.length - 1))); }
      if (prev) prev.addEventListener('click', function () { jumpTo(index() - 1); });
      if (next) next.addEventListener('click', function () { jumpTo(index() + 1); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { jumpTo(j); }); });
      nums.forEach(function (d, j) { d.addEventListener('click', function () { jumpTo(j); }); });

      /* Settle handler covers free scrolling / swipes. Skip if the landed slide
         is already the one playing, so we don't restart it after a click. */
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var i = index();
          if (i !== current) scheduleSlide(i);
        }, 600);
      });

      var pause = root.querySelector('[data-pause]');
      if (pause) {
        pause.addEventListener('click', function () {
          paused = !paused;
          pause.textContent = paused ? '▶' : '⏸';
          var i = index();
          var video = slides[i] && slides[i].querySelector('video');
          if (paused) {
            clearScheduled();
            if (video) video.pause();
          } else {
            scheduleSlide(i);
          }
        });
      }
    }
  }
  document.querySelectorAll('.lswiper').forEach(initSwiper);

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var i = 0;
    var paused = false;
    setInterval(function () {
      if (paused) return;
      slides[i].hidden = true;
      i = (i + 1) % slides.length;
      slides[i].hidden = false;
    }, 5000);
    bar.querySelectorAll('.announcement-bar__pause').forEach(function (btn) {
      btn.addEventListener('click', function () {
        paused = !paused;
        bar.querySelectorAll('.announcement-bar__pause').forEach(function (b) {
          b.textContent = paused ? '▶' : '⏸';
        });
      });
    });
  });

  /* ---------- Mobile menu drawer ---------- */
  var drawer = document.querySelector('.menu-drawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  if (drawer && openBtn) {
    openBtn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (drawer && closeBtn) {
    closeBtn.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------- Collection grid: randomize card order on each load ---------- */
  /* Runs before scroll-reveal so the stagger delays follow the shuffled order.
     Only the product cards are shuffled — the sizing promo stays pinned to the
     top-left, so re-appending the shuffled cards leaves it as the first item. */
  document.querySelectorAll('.collection__grid').forEach(function (grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .card-wrapper'));
    if (items.length < 2) return;
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    items.forEach(function (el) { grid.appendChild(el); });
  });

  /* ---------- Scroll reveal ---------- */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    /* [selector, stagger items within the same parent] */
    var targets = [
      ['.hero__content > *', true],
      ['.heading-section', false],
      ['.products-swiper .pcard', true],
      ['.multicolumn-images .lswiper__track > *', true],
      ['.statistics__cell', true],
      ['.campaign-block', true],
      ['.stats-feature__main, .stats-feature__panel', true],
      ['.side-image-text__container > *', true],
      ['.ugc-item', true],
      ['.content-card', true],
      ['.email-optin__inner > *', true],
      ['.brand-banner__title, .brand-banner__svg', false],
      ['.pdp__gallery, .pdp__buybox', true],
      ['.why-card', true],
      ['.collection__grid > *', true],
      ['.blog__featured', false],
      ['.blog__grid > *', true],
      ['.article__related-grid > *', true],
      ['.faq__group', true],
      ['.contact__primary > *, .contact-route', true],
      ['.cart__item, .cart__summary', true],
      ['.search__grid > *', true],
      ['.e404__code, .e404__title, .e404__text, .e404__actions', true],
      ['.how-it-works__step, .how-it-works__usp', true],
      ['.quiz__card, .quiz__result', false],
      ['.legal__prose > div', true],
      ['.page__prose > h2, .page__prose > p', true],
      ['.collections-index__grid > *', true],
      ['.size-steps__card', true]
    ];

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (t) {
      var els = document.querySelectorAll(t[0]);
      var lastParent = null;
      var i = 0;
      els.forEach(function (el) {
        if (t[1]) {
          i = el.parentNode === lastParent ? i + 1 : 0;
          lastParent = el.parentNode;
          el.style.setProperty('--reveal-delay', Math.min(i, 7) * 70 + 'ms');
        }
        el.classList.add('reveal');
        io.observe(el);
      });
    });
  })();

  /* ---------- Desktop mega menu ---------- */
  document.querySelectorAll('[data-mega-trigger]').forEach(function (li) {
    var panel = document.querySelector(li.getAttribute('data-mega-trigger'));
    if (!panel) return;
    var hideTimer;
    function show() { clearTimeout(hideTimer); panel.classList.add('is-open'); }
    function hide() { hideTimer = setTimeout(function () { panel.classList.remove('is-open'); }, 150); }
    li.addEventListener('mouseenter', show);
    li.addEventListener('mouseleave', hide);
    panel.addEventListener('mouseenter', show);
    panel.addEventListener('mouseleave', hide);
  });

  /* ---------- Header language picker ---------- */
  document.querySelectorAll('[data-lang-picker]').forEach(function (picker) {
    var toggle = picker.querySelector('[data-lang-toggle]');
    var menu = picker.querySelector('[data-lang-menu]');
    if (!toggle || !menu) return;

    function close() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) { open(); } else { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  /* ---------- PDP: thumbnail gallery ---------- */
  var mainImage = document.getElementById('pdp-main-image');
  if (mainImage) {
    document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-image');
        var img = thumb.querySelector('img');
        var src = full || (img && img.src);
        if (src) { mainImage.removeAttribute('srcset'); mainImage.src = src; }
        document.querySelectorAll('.pdp__thumb').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* ---------- PDP: sticky add-to-cart bar ---------- */
  var sticky = document.querySelector('[data-pdp-sticky]');
  var buybox = document.querySelector('.pdp__buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(buybox);
  }

  /* ---------- Option pills (swatches, sizes, chips) ---------- */
  function exclusiveSelect(groupSelector, itemSelector, className) {
    document.querySelectorAll(groupSelector).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var item = e.target.closest(itemSelector);
        if (!item || !group.contains(item)) return;
        group.querySelectorAll(itemSelector).forEach(function (el) {
          el.classList.toggle(className, el === item);
        });
      });
    });
  }
  exclusiveSelect('.blog__chips', '.chip', 'is-active');

  /* ---------- PDP: variant selection + AJAX add to cart ---------- */
  (function () {
    var form = document.getElementById('pdp-product-form');
    var dataEl = document.querySelector('[data-product-json]');
    if (!form || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    var pdpRoot = form.closest('.pdp') || form;
    var priceEls = pdpRoot.querySelectorAll('[data-price]');
    var mainImage = document.getElementById('pdp-main-image');
    var optionGroups = [].slice.call(form.querySelectorAll('[data-pdp-option]'));

    function selectedValues() {
      return optionGroups.map(function (g) {
        var sel = g.querySelector('[data-option-value].is-selected');
        return sel ? sel.getAttribute('data-option-value') : null;
      });
    }
    function matchVariant(vals) {
      return variants.filter(function (v) {
        return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }
    function update() {
      var vals = selectedValues();
      optionGroups.forEach(function (g) {
        var sel = g.querySelector('[data-option-value].is-selected');
        var lbl = g.querySelector('[data-option-selected]');
        if (sel && lbl) lbl.textContent = sel.getAttribute('data-option-value');
      });
      var v = matchVariant(vals);
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = atc.dataset.labelUnavailable || 'Not available'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price; });
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available
          ? (atc.dataset.labelAddToCart || '').replace('__PRICE__', v.price)
          : (atc.dataset.labelSoldOut || 'Sold out');
      }
      if (mainImage && v.image) { mainImage.removeAttribute('srcset'); mainImage.src = v.image; }
    }
    optionGroups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || !g.contains(btn)) return;
        g.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        update();
      });
    });

    var busy = false;
    function addToCart() {
      if (busy || !atc || atc.disabled) return;
      busy = true;
      atc.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      }).then(function (res) {
        atc.classList.remove('is-loading');
        busy = false;
        if (!res.ok) { return; }
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
        atc.classList.add('is-added');
        atc.textContent = atc.dataset.labelAdded || 'Added';
        setTimeout(function () { atc.classList.remove('is-added'); update(); }, 1800);
      }).catch(function () {
        atc.classList.remove('is-loading');
        busy = false;
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) { form.requestSubmit(); } else { addToCart(); }
    });

    update();
  })();

  /* ---------- Product cards: interactive colour swatches ---------- */
  document.querySelectorAll('.pcard').forEach(function (card) {
    var swatches = card.querySelectorAll('.pcard__swatch[data-variant-id]');
    if (!swatches.length) return; /* static/preview card — leave as-is */
    var img = card.querySelector('.pcard__img');
    var hoverImg = card.querySelector('.pcard__hover-img');
    var priceEl = card.querySelector('.pcard__price');
    var nameEl = card.querySelector('.pcard__swatch-label .val');
    var variantInput = card.querySelector('.pcard__variant-id');
    var atc = card.querySelector('.pcard__atc');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        var im = sw.getAttribute('data-image');
        if (img && im) { img.removeAttribute('srcset'); img.setAttribute('src', im); }
        if (hoverImg) {
          var hoverSrc = sw.getAttribute('data-hover-image');
          if (hoverSrc) { hoverImg.setAttribute('src', hoverSrc); }
          else { hoverImg.removeAttribute('src'); }
        }
        var pr = sw.getAttribute('data-price');
        if (priceEl && pr) priceEl.textContent = pr;
        var nm = sw.getAttribute('data-color');
        if (nameEl && nm) nameEl.textContent = nm;
        var vid = sw.getAttribute('data-variant-id');
        if (variantInput && vid) variantInput.value = vid;
        if (atc) atc.disabled = (sw.getAttribute('data-available') === 'false');
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('.qty__input');
    if (!input) return;
    function step(delta) {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
  });

  /* ---------- Cart page: quantity + remove (AJAX) ---------- */
  (function () {
    var cartRoot = document.querySelector('[data-cart]');
    if (!cartRoot) return;
    var busy = false;

    function changeLine(line, quantity) {
      if (busy) return;
      busy = true;
      cartRoot.classList.add('is-updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        window.location.reload();
      });
    }

    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      changeLine(parseInt(rm.getAttribute('data-cart-remove'), 10), 0);
    });

    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('.qty__input[data-line]');
      if (!input) return;
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(input.getAttribute('data-line'), 10), q);
    });
  })();

  /* ---------- FAQ: category tabs + search ---------- */
  var faqTabs = document.querySelector('[data-faq-tabs]');
  if (faqTabs) {
    var groups = document.querySelectorAll('[data-faq-cat]');
    faqTabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-faq-tab]');
      if (!tab) return;
      faqTabs.querySelectorAll('.chip').forEach(function (c) {
        c.classList.toggle('is-active', c === tab);
      });
      var cat = tab.getAttribute('data-faq-tab');
      groups.forEach(function (g) {
        g.classList.toggle('is-hidden', cat !== 'alle' && g.getAttribute('data-faq-cat') !== cat);
      });
    });
    var faqSearch = document.querySelector('[data-faq-search]');
    if (faqSearch) {
      faqSearch.addEventListener('input', function () {
        var q = faqSearch.value.trim().toLowerCase();
        groups.forEach(function (g) {
          var any = false;
          g.querySelectorAll('.acc').forEach(function (acc) {
            var hit = !q || acc.textContent.toLowerCase().indexOf(q) !== -1;
            acc.style.display = hit ? '' : 'none';
            if (hit) any = true;
          });
          g.classList.toggle('is-hidden', !any);
        });
      });
    }
  }

  /* ---------- Brauche-ich quiz ---------- */
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var quizAnswers = {};
    var quizChecks = [];
    var quizSteps = quiz.querySelectorAll('[data-quiz-step]');
    var quizResult = quiz.querySelector('[data-quiz-result]');
    var quizResultCards = quiz.querySelectorAll('[data-quiz-category]');
    var quizCheckBtns = quiz.querySelectorAll('[data-quiz-check]');

    function quizShowStep(n) {
      quizSteps.forEach(function (s) {
        s.classList.toggle('is-hidden', s.getAttribute('data-quiz-step') !== String(n));
      });
      quizResult.classList.add('is-hidden');
    }

    function quizCategory() {
      if (quizAnswers.priority === 'opening') return 'therapie';
      if (quizAnswers.situation === 'schlafen') return 'schlaf';
      if (quizAnswers.situation === 'ausgehen') return 'style';
      return quizAnswers.situation === 'alltag' ? 'alltag' : 'sport';
    }

    function quizShowResult(forced) {
      var category = forced || quizCategory();
      quizResultCards.forEach(function (card) {
        card.classList.toggle('is-hidden', card.getAttribute('data-quiz-category') !== category);
      });
      quizSteps.forEach(function (s) { s.classList.add('is-hidden'); });
      quizResult.classList.remove('is-hidden');
    }

    quiz.addEventListener('click', function (e) {
      var checkBtn = e.target.closest('[data-quiz-check]');
      if (checkBtn) {
        var val = checkBtn.getAttribute('data-quiz-value');
        var idx = quizChecks.indexOf(val);
        if (idx === -1) { quizChecks.push(val); } else { quizChecks.splice(idx, 1); }
        checkBtn.classList.toggle('is-selected', idx === -1);
        checkBtn.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false');
        return;
      }
      if (e.target.closest('[data-quiz-continue]')) {
        if (quizChecks.indexOf('nasen-op') !== -1 || quizChecks.indexOf('eingefallen') !== -1) {
          quizShowResult('therapie');
        } else {
          quizShowStep(1);
        }
        return;
      }
      var answerBtn = e.target.closest('[data-quiz-answer]');
      if (answerBtn) {
        var q = answerBtn.getAttribute('data-quiz-q');
        quizAnswers[q] = answerBtn.getAttribute('data-quiz-value');
        if (q === 'situation') { quizShowStep(2); } else { quizShowResult(); }
        return;
      }
      if (e.target.closest('[data-quiz-reset]')) {
        quizAnswers = {};
        quizChecks = [];
        quizCheckBtns.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        quizShowStep(0);
      }
    });
  }

  /* ---------- Article: copy share link ---------- */
  document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard.writeText(window.location.href).then(function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
      }).catch(function () {});
    });
  });

  /* ---------- Collection: sort select ---------- */
  document.querySelectorAll('[data-collection-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
